// assets
import {
  IconBackpack,
  IconBuildingCommunity,
  IconCalendar,
  IconMoneybag,
  IconBook,
  IconBook2,
  IconWriting,
  IconCalendarTime,
  IconSchool,
  IconBooks
} from '@tabler/icons';
import { createChildGroupMenuItem, createChildMenuItem, createMenuItem } from 'utils/menu';

const item = [
  createMenuItem('harga', 'harga.read', 'Daftar Harga', '/data/harga', IconMoneybag, false),
  // createMenuItem('sekolah', 'sekolah.read', 'Sekolah', '/data/sekolah', IconSchool, false),
  createMenuItem('cabang', 'cabang.read', 'Cabang Les', '/data/cabang', IconBuildingCommunity, false),
  createMenuItem('tahunajaran', 'tahunajaran.read', 'Tahun Ajaran', '/data/tahunajaran', IconCalendar, false),
  createMenuItem('jenjang', 'jenjang.read', 'Jenjang Pendidikan', '/data/jenjang', IconBackpack, false),
  createMenuItem('mapel', 'mapel.read', 'Mata Pelajaran', '/data/mapel', IconBook2, false),
  createMenuItem('mapelbab', 'mapelbab.read', 'Bab Mata Pelajaran', '/data/bab', IconBook, false),
  createMenuItem('examtype', 'examtype.read', 'Tipe Ujian', '/data/examtype', IconWriting, false),
  createMenuItem('subscriptiontype', 'subscriptiontype.read', 'Tipe Langganan', '/data/subscriptiontype', IconCalendarTime, false),
  createMenuItem('schooltype', 'schooltype.read', 'Tipe Sekolah', '/data/schooltype', IconSchool, false),
  createMenuItem('classtype', 'classtype.read', 'Tipe Kelas', '/data/classtype', IconBooks, false)
];
const children = [
  {
    id: 'master',
    title: 'Data Master',
    type: 'collapse',
    icon: IconBook2,
    children: createChildMenuItem(item)
  }
];

const data = {
  id: 'data',
  title: '',
  type: 'group',
  children: createChildGroupMenuItem(children)
};

export default data;
